export default {
    header: 'Refer to a provider in your Network',
    table: {
        provider: 'Provider',
        specialty: 'Specialty',
        location: 'location',
        insurance: 'Insurance',
        availability: 'AVAILABILITY',
        view_more: 'VIEW MORE',
        search_zip_code: 'Search zip code',
        per_page: 'per page',
    },
}
